<app-public-top-nav class="top-navbar"></app-public-top-nav>

<div class="below-nav-container">
  <router-outlet></router-outlet>
</div>
